import { render, staticRenderFns } from "./commonPositionList.vue?vue&type=template&id=c2ea9d3c&scoped=true"
import script from "./commonPositionList.vue?vue&type=script&lang=js"
export * from "./commonPositionList.vue?vue&type=script&lang=js"
import style0 from "./commonPositionList.vue?vue&type=style&index=0&id=c2ea9d3c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea9d3c",
  null
  
)

export default component.exports